export enum BloomreachEventName {
  SEARCH_BUTTON_CLICK = 'search_button_click',
  SERP_PAGE_OPEN = 'serp_page_open',
  OFFER_PRICE_CLICK = 'offer_price_click',
  FARE_SELECT = 'ff_choose_click',
  REVENUE_PAGE_OPEN = 'revenue_page_open',
  SUCCESS_BOOKING = 'success_booking',
  PAYMENT_CLICK = 'pay_button_click',
  NPS_SURVEY_SHOWN = 'nps_survey_shown',
  NPS_SURVEY_SUBMITTED = 'nps_survey_submitted',
  NPS_SURVEY_DISMISSED = 'nps_survey_dismissed',
}
